<div
  *ngIf="!question?.hidden"
  [formGroup]="form"
  [ngSwitch]="question.controlType"
  [ngClass]="currentClasses"
>
  <label *ngIf="question.label" [attr.for]="question.key">{{ question.label | translate }}</label>

  <input
    *ngSwitchCase="'textbox'"
    [ngClass]="{ failed: !isValid || (formError && question.key === 'userName') }"
    [id]="question.key"
    placeholder="{{ question.placeholder | translate }}"
    [formControlName]="question.key"
    [type]="question.type"
  />

  <input
    *ngSwitchCase="'number'"
    [ngClass]="{ failed: !isValid }"
    [id]="question.key"
    placeholder="{{ question.placeholder | translate }}"
    [formControlName]="question.key"
    type="number"
  />

  <input
    *ngSwitchCase="'hidden'"
    [ngClass]="{ failed: !isValid }"
    [id]="question.key"
    placeholder="{{ question.placeholder | translate }}"
    [formControlName]="question.key"
    type="hidden"
  />

  <ng-container *ngSwitchCase="'passwordbox'">
    <div class="form__field--icon">
      <input
        [id]="question.key"
        [ngClass]="{ failed: !isValid }"
        placeholder="{{ question.placeholder | translate }}"
        [formControlName]="question.key"
        [type]="passwordClear ? 'text' : 'password'"
      />
      <i
        [ngClass]="{ 'glicon-view': passwordClear, 'glicon-no-view': !passwordClear }"
        (click)="passwordClear = !passwordClear"
      ></i>
    </div>
    <!-- <gl-password-constraints *ngIf="!question.checkStrength" [target]="question.key" [password]="form.value[question.key]"></gl-password-constraints> -->
    <app-password-strength-bar
      *ngIf="question.checkStrength"
      [passwordToCheck]="form.value[question.key]"
      [target]="question.key"
    >
    </app-password-strength-bar>
  </ng-container>

  <ng-container *ngSwitchCase="'textarea'">
    <textarea class="textarea" [id]="question.key" [formControlName]="question.key"></textarea>
    <p *ngIf="!!textareaTip" class="small">{{ textareaTip }}</p>
  </ng-container>

  <ng-container *ngSwitchCase="'simpleselect'">
    <lms-select-dropdown
      [id]="question.key"
      [formControlName]="question.key"
      [items]="question.items"
      size="large"
    ></lms-select-dropdown>
  </ng-container>

  <div *ngSwitchCase="'link'" class="form-link">
    <textarea #link class="textarea" readonly [value]="question.value"></textarea>
    <a class="btn btn--primary" (click)="question.copy(link)">{{ 'actions.copy' | translate }}</a>
  </div>

  <mat-form-field *ngSwitchCase="'dropdown'">
    <mat-select [formControlName]="question.key" *ngSwitchCase="'dropdown'">
      <mat-option *ngFor="let opt of question.options" [value]="opt.key">
        {{ opt.value | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="checkbox" [ngClass]="question.checkboxClass" *ngSwitchCase="'checkbox'">
    <input type="checkbox" [id]="question.key" [formControlName]="question.key" />
    <label [attr.for]="question.key" class="">{{ question.checkboxLabel | translate }}</label>
  </div>

  <ng-container *ngSwitchCase="'radiobutton'">
    <div class="radio" *ngFor="let opt of question.options">
      <input
        type="radio"
        [id]="opt.key"
        [formControlName]="question.key"
        [(ngModel)]="question.value"
      />
      <label *ngSwitchCase="'radiobutton'" [attr.for]="opt.key">{{ opt.value }}</label>
    </div>
  </ng-container>

  <div *ngIf="!isValid && question.controlType !== 'group'" class="form__error">
    <span class="glicon-alert-thin"></span>
    <span *ngFor="let error of errors; let first = first"
      >{{ !first ? ', ' : '' }}{{ error.message | translate : error.params }}</span
    >
  </div>
  <div *ngIf="formError && question.key === 'userName'" class="form__error">
    <span class="glicon-alert-thin"></span>
    <span>
      <app-dynamic-form-error [formError]="formError"> </app-dynamic-form-error>
    </span>
  </div>
</div>
